import { useState } from 'react';
import { authStaff } from '../../../utils/constants';
import { fetchRequests } from '../../../Requests/getRequests';
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from '../../../slices/staffSlice';
import { Loader, Tooltip } from "../../../components";
import { show } from '../../../slices/toastSlice';
import { useNavigate } from 'react-router-dom';

function ToggleSuspend({ _id, status, setClientList }) {

    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [process, setProcess] = useState(false);

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    const toggleRequest = async(e) => {
        e.preventDefault();
        setProcess(true);

        let toggleUrl = `/auth/staff/client/disable`;
        let headers = authStaff(accessToken);

        let data = {
            _id : _id
        }

        let res = await fetchRequests(toggleUrl, "PUT", headers, {}, data)
        setProcess(false);

        if(res?.code === 401){
            // clear local storage and redirect to login
            sessionStorage.clear();
			navigate("/login");
            dispatch(show({
                type : "error",
                state : true,
                message : "Your session has expired. Please login to continue."
            }))
            return;
        }

        if(res?.err){
            dispatch(show({
                type : "error",
                state : true,
                message : `${res?.err}`
            }))
            return;
        }

        dispatch(show({
            type : "success",
            state : true,
            message : `${res?.message}`
        }))

        setClientList(res?.clients)

    }
    
    return (
        <span className={classNames ("cursor-pointer inline-flex items-center", status ? "text-emerald-700 hover:text-emerald-600" : "text-red-500 hover:text-red-700")} onClick={toggleRequest}>
            {status ? 
                <Tooltip text={"Unban client"} position="left">
                    <span className='inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20'>
                        Unban
                    </span>
                </Tooltip>
                : 
                <Tooltip text={"Ban client"} position="left">
                    <span className='inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10'>
                        Ban
                    </span>
                </Tooltip>
            } {process && <Loader color="text-gray-600 ml-3" size="4" />}
        </span>
    )
}

export default ToggleSuspend